// 菜单 顶栏
export default [
  { path: '/operate/msg/tabs',
    title: '消息',
    icon: 'commenting',
    hideDot: true,
    dotCount: 0,
    handleClick () {
      this.$bus.$emit('msgListReLoad')
    } }
]
